import { useSyncExternalStore } from 'react'

import {
  getDesktopPushState,
  subscribeDesktopPush,
  type DesktopPushState,
} from '../services/webPush'

/** حالة تنبيهات سطح المكتب لهذا المتصفح — الإذن والاشتراك — تتبدّل حيّةً بين الشاشات */
export function useDesktopPush(): DesktopPushState {
  return useSyncExternalStore(subscribeDesktopPush, getDesktopPushState, getDesktopPushState)
}
